import React from 'react';

function EmotionalWellbeing({ iframelink }) {

  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <iframe src={iframelink} className='iframe-box'></iframe>
        </div>
      </div>
    </>
  );
}

export default EmotionalWellbeing;
